import SubFormRow from '../SubFormRow.vue'
import { filter, get } from 'lodash'

export default {
  components: {
    SubFormRow,
  },
  props: {
    listHead: {
      type: Array,
      default: () => [],
    },
    path: {
      type: String,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    field() {
      return this.$get('fieldByPath')(this.path) || {}
    },
    isListView() {
      return this.subFormView === 'List'
    },
    isFormGridView() {
      return this.subFormView === 'FormGrid'
    },
    isCollapsibleFormGridView() {
      return this.subFormView === 'CollapsibleGrid'
    },
    isSubformInvalid() {
      return filter(this.$get('messages'), { name: this.name, type: 'error' }).length > 0
    },
    label() {
      return get(this.field, 'label')
    },
    maxRecCount() {
      return get(this.field, 'maxRecCount', 0)
    },
    minRecCount() {
      return get(this.field, 'minRecCount', 0)
    },
    name() {
      return get(this.field, 'name')
    },
    removable() {
      return get(this.field, 'subRecDeletable', false)
    },
    rows() {
      return get(this.$get('subFormByPath')(this.path), 'rows', [])
    },
    showEditButton() {
      return !this.readOnly && this.isListView
    },
    showRemoveButton() {
      return !this.readOnly && this.removable
    },
    showWithHeader() {
      return !get(this.field, 'subformPure', false)
    },
    subFormView() {
      return this.$get('subformView')
    },
    id() {
      return get(this.field, 'id')
    },
  },
  methods: {
    onEditRowClick(rowIndex) {
      this.$emit('edit-row-click', { index: rowIndex, discardAction: 'cache' })
    },
    onRemoveRowClick(rowIndex) {
      this.$emit('remove-row-click', rowIndex)
    },
    checkRowUids() {
      this.rows.forEach((row, index) => {
        if (!row.rowUid) {
          this.$dispatch('setRowUid', { index, path: this.path })
        }
      })
    },
  },
  mounted() {
    this.checkRowUids()
  },
}
